import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleAlbumMetaData: (field: string, value: string | null) => void;
};

export default function InternalDescriptionFormGroup({
  album,
  disabled,
  readonly,
  fieldHasErrors,
  findErrorMessage,
  handleAlbumMetaData,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.internalDescription')}
        handleInput={(e) =>
          handleAlbumMetaData('internalDescription', e.target.value)
        }
        id="internalDescription"
        type="text"
        value={album.albumMetaData?.internalDescription?.toString() ?? ''}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={fieldHasErrors('InternalDescription')}
        errorMessage={findErrorMessage('InternalDescription')}
      />
    </div>
  );
}
